export const API_URL = process.env.REACT_APP_API_URL || '';
export const SLACK_AUTH_URL = process.env.REACT_APP_SLACK_AUTH_URL || '';
export const SLACK_CLIENT_ID = process.env.REACT_APP_SLACK_CLIENT_ID || '';
export const SLACK_REDIRECT_URI =
  process.env.REACT_APP_SLACK_REDIRECT_URI || '';
export const SLACK_WORKSPACE_URL =
  process.env.REACT_APP_SLACK_WORKSPACE_URL || '';
